import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Header from '../components/Header';
import VigilanciaPassivaTab from '../components/VigilanciaAtivaTab';
import '../components/Dashboard.css';

const VigilanciaPassivaPage = () => {
    const navigate = useNavigate();
    const municipioId = localStorage.getItem('user_municipio_id');

    const [casos,     setCasos]     = useState([]);
    const [pitsCount, setPitsCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const carregarCasos = useCallback(async () => {
        if (!municipioId) return;
        setIsLoading(true);
        try {
            // A view não tem municipio_id — busca os IDs das denúncias do município primeiro
            const { data: denIds, error: denIdsError } = await supabase
                .from('denuncias').select('id').eq('cidade', municipioId);
            if (denIdsError) throw denIdsError;

            const denunciaIds = (denIds || []).map(d => d.id);
            setPitsCount(denunciaIds.length);

            if (denunciaIds.length === 0) { setCasos([]); return; }

            const { data: casosData, error: casosError } = await supabase
                .from('casos_de_vigilancia').select('*').in('denuncia_id', denunciaIds);
            if (casosError) throw casosError;

            const casos = (casosData || []).map(c => ({
                ...c,
                id: c.ocorrencia_id,
                denuncia_status:   c.status_denuncia,
                denuncia_feedback: c.feedback_agente,
                data_atividade:    c.ocorrencia_data_atividade,
                fotos_urls:        c.ocorrencia_fotos || [],
                tipo_atividade:    c.ocorrencia_atividades,
                endereco:          c.ocorrencia_endereco,
                numero:            c.ocorrencia_numero,
                complemento:       c.ocorrencia_complemento,
                localidade:        c.ocorrencia_nome_localidade,
                inseticida:        c.ocorrencia_inseticida,
                numero_cargas:     c.ocorrencia_cargas,
                numero_pit:              c.ocorrencia_numero_pit,
                codigo_etiqueta:         c.ocorrencia_codigo_etiqueta,
                codigo_localidade:       c.ocorrencia_codigo_localidade,
                categoria_localidade:    c.ocorrencia_categoria_localidade,
                nome_morador:            c.ocorrencia_nome_morador,
                quantidade_moradores:    c.ocorrencia_quantidade_moradores,
                numero_anexo:            c.ocorrencia_numero_anexo,
                situacao_imovel:         c.ocorrencia_situacao_imovel,
                tipo_parede:             c.ocorrencia_tipo_parede,
                tipo_teto:               c.ocorrencia_tipo_teto,
                melhoria_habitacional:   c.ocorrencia_melhoria_habitacional,
                pendencia_pesquisa:      c.ocorrencia_pendencia_pesquisa,
                pendencia_borrifacao:    c.ocorrencia_pendencia_borrifacao,
                vestigios_intradomicilio: c.ocorrencia_vestigios_intradomicilio,
                barbeiros_intradomicilio: c.ocorrencia_barbeiros_intradomicilio,
                vestigios_peridomicilio:  c.ocorrencia_vestigios_peridomicilio,
                barbeiros_peridomicilio:  c.ocorrencia_barbeiros_peridomicilio,
                origem_status: c.status_denuncia === 'recusada' ? 'Denúncia Recusada' : c.origem_status,
            }));

            const ocorrenciaIds = casos.map(c => c.id).filter(Boolean);
            let examesPorOcorrencia = {};
            if (ocorrenciaIds.length > 0) {
                const { data: examesData } = await supabase
                    .from('exames').select('*, exames_exemplares(*)').in('ocorrencia_id', ocorrenciaIds);
                (examesData || []).forEach(ex => { examesPorOcorrencia[ex.ocorrencia_id] = ex; });
            }

            setCasos(casos.map(caso => ({
                ...caso,
                exame: caso.id ? (examesPorOcorrencia[caso.id] || null) : null,
            })));
        } catch (err) {
            console.error('Erro ao carregar casos de vigilância passiva:', err);
        } finally {
            setIsLoading(false);
        }
    }, [municipioId]);

    useEffect(() => {
        if (!municipioId) { navigate('/'); return; }
        carregarCasos();
    }, [municipioId, navigate, carregarCasos]);

    const handleRecusarDenuncia = useCallback(async (denunciaId, motivo) => {
        try {
            await supabase.from('denuncias')
                .update({ status: 'recusada', feedback_agente: motivo })
                .eq('id', denunciaId);
            carregarCasos();
        } catch (err) {
            console.error('Erro ao recusar denúncia:', err);
        }
    }, [carregarCasos]);

    if (!municipioId) return null;

    return (
        <div className="portal-layout">
            <Header activeView="vigilancia_passiva" />
            <main className="main-content">
                {isLoading ? (
                    <div className="content-container">
                        <div className="loading-screen"><div className="spinner" /><p>Carregando notificações...</p></div>
                    </div>
                ) : (
                    <div className="content-container">
                        <div className="tab-header-container">
                            <div className="tab-title-group">
                                <h1 className="tab-title-main">Vigilância Passiva</h1>
                                <p className="tab-subtitle-main">Atendimento às notificações de cidadãos.</p>
                            </div>
                        </div>
                        <VigilanciaPassivaTab
                            casos={casos}
                            kpis={{ pits: pitsCount }}
                            municipioId={municipioId}
                            onRecusarDenuncia={handleRecusarDenuncia}
                        />
                    </div>
                )}
            </main>
        </div>
    );
};

export default VigilanciaPassivaPage;
